import { Card } from "react-bootstrap"

import Osirase from "./Osirase/Osirase"
import NewTumiorosisakiList from "./NewTumiorosisakiList/NewTumiorosisakiList"
import BusyoUriagegaku from "./BusyoUriagegaku/BusyoUriagegaku"
import HaisyaKensu from "./HaisyaKensu/HaisyaKensu"
import SyakenTenkenMenkyoList from "./SyakenTenkenMenkyo/SyakenTenkenMenkyoList"


const Top = () => {
  return (
    <div className="w-100 d-flex h-100">
      <div className="w-50 p-3 pe-2 ">
        <Card style={{ width: "100%", height: "100%", position: "relative" }}>
          <Card.Body>
            <h4 className="topLabel">運行情報</h4>
            <div className="mb-4" style={{ height: "35%" }}>
              <BusyoUriagegaku></BusyoUriagegaku>
            </div>
            <div style={{ height: "30%" }}>
              <HaisyaKensu></HaisyaKensu>
            </div>
            <div style={{ height: "35%" }}>
              <NewTumiorosisakiList></NewTumiorosisakiList>
            </div>
          </Card.Body>
        </Card>
      </div>
      <div className="w-50 p-3 ps-1 h-100">
        <Card style={{ height: "40%", minHeight: "10rem", maxHeight: "40%" }}>
          <Card.Body>
            <h4 className="topLabel">今月の車検・点検・免許更新</h4>
            <div>
              <SyakenTenkenMenkyoList></SyakenTenkenMenkyoList>
            </div>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>開発中</Card.Header>
          <Card.Body
            style={{
              height: "20%",
              minHeight: "10rem",
              maxHeight: "20%",
            }}></Card.Body>
        </Card>
        <Osirase></Osirase>
      </div>
    </div>
  )
}

export default Top
